import { useEffect, type FunctionComponent, type PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import { identify } from '@fff-web/fff-analytics';
import { useUserContext } from '@fff-web/fff-utilities';

const AnalyticsWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { userInfo } = useUserContext();
  const location = useLocation();
  useEffect(() => {
    identify({
      traits: {
        planCode: userInfo?.user?.planCode,
      },
    });
  }, [location, userInfo]);
  return <>{children}</>;
};

export default AnalyticsWrapper;
